export default __webpack_public_path__ + "static/media/SearchFallBackIcon.242e7de7.svg";